// extracted by mini-css-extract-plugin
export default {"container":"zp8IQu","loaderBox":"WqSDrh"};